module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper animate fadeIn"
  }, [_c('div', {
    staticClass: "container upload-slip"
  }, [_c('h1', {
    staticClass: "header-title"
  }, [_vm._v("แจ้งโอนเงิน #" + _vm._s(this.orderId))]), _vm._v(" "), _c('div', {
    staticClass: "block-primary block shadow radius mb-15"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "orderid"
    }
  }, [_vm._v("เลขที่การบริจาค")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.orderId),
      expression: "info.orderId"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('orderId')
    },
    attrs: {
      "type": "text",
      "name": "orderid",
      "id": "orderid",
      "disabled": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.info.orderId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "orderId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.orderId.empty),
      expression: "$v.$errors.orderId.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกเลขที่บริจาค")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "bank"
    }
  }, [_vm._v("โอนจากธนาคาร")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.bankCode),
      expression: "info.bankCode"
    }],
    staticClass: "form__input text-left",
    class: {
      'form__input--error': _vm.$v.isError('bankCode')
    },
    attrs: {
      "id": "bank",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.info, "bankCode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$utils.banks), function(bank) {
    return _c('option', {
      key: bank.code,
      domProps: {
        "value": bank.code
      }
    }, [_vm._v(_vm._s(bank.name_th) + " (" + _vm._s(bank.name_en) + ")")])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.bankCode.empty),
      expression: "$v.$errors.bankCode.empty"
    }],
    staticClass: "alert alert--error mt-15"
  }, [_vm._v("กรุณาระบุธนาคารที่โอน")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("จำนวนเงินที่โอน (บาท)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.amount),
      expression: "info.amount"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('amount')
    },
    attrs: {
      "id": "amount",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.info.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "amount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.amount.empty),
      expression: "$v.$errors.amount.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาระบุจำนวนเงินที่โอนมาจริงๆ (ใส่ทศนิยมด้วยถ้ามี) เพื่อง่ายต่อการตรวจสอบ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.amount.invalid),
      expression: "$v.$errors.amount.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาระบุจำนวนเงินให้ถูกต้อง เป็นตัวเลขและจุดทศนิยม 2 หลักเท่านั้น")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-3"
  }, [_c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "date"
    }
  }, [_vm._v("วันที่โอน")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.date),
      expression: "info.date"
    }, {
      name: "pikaday",
      rawName: "v-pikaday:selected",
      value: (_vm.setDate),
      expression: "setDate",
      arg: "selected"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.$v.isError('date')
    },
    attrs: {
      "id": "date",
      "placeholder": "01/12/2018",
      "type": "text",
      "readonly": "",
      "maxDate": _vm.maxDate,
      "required": ""
    },
    domProps: {
      "value": (_vm.info.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.date.empty),
      expression: "$v.$errors.date.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณาเลือกวันที่โอน")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3"
  }, [_c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_vm._v("เวลาที่โอน ( เช่น 14:50 )")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.hour),
      expression: "info.hour"
    }],
    staticClass: "form__input form__input--sm text-left",
    class: {
      'form__input--error': _vm.$v.isError('hour')
    },
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.info, "hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$utils.range(0, 23)), function(i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": _vm.pad(i)
      }
    }, [_vm._v(_vm._s(_vm.pad(i)))])
  }), 0), _vm._v(" :\n              "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.minute),
      expression: "info.minute"
    }],
    staticClass: "form__input form__input--sm text-left",
    class: {
      'form__input--error': _vm.$v.isError('minute')
    },
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.info, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$utils.range(0, 59)), function(i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": _vm.pad(i)
      }
    }, [_vm._v(_vm._s(_vm.pad(i)))])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.hour.empty || _vm.$v.$errors.minute.empty),
      expression: "$v.$errors.hour.empty || $v.$errors.minute.empty"
    }],
    staticClass: "alert alert--error mt-15"
  }, [_vm._v("กรุณาระบุเวลาที่โอน")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.hour.invalid || _vm.$v.$errors.minute.invalid),
      expression: "$v.$errors.hour.invalid || $v.$errors.minute.invalid"
    }],
    staticClass: "alert alert--error mt-15"
  }, [_vm._v("กรุณาระบุเวลาที่โอนให้ถูกต้อง")])])])]), _vm._v(" "), _c('upload-picker', {
    attrs: {
      "order-id": _vm.info.orderId
    },
    on: {
      "uploaded": _vm.imageUploaded
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.imageUrl.empty),
      expression: "$v.$errors.imageUrl.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("โปรด upload รูปภาพก่อน")]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("ข้อมูลเพิ่มเติม")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.message),
      expression: "info.message"
    }],
    staticClass: "form__input",
    attrs: {
      "id": "message"
    },
    domProps: {
      "value": (_vm.info.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "message", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--purple btn-md"
  }, [_vm._v("ส่งหลักฐานการโอนเงิน")]), _vm._v(" "), _c('p', [_vm._v("เมื่อเจ้าหน้าที่ตรวจสอบการโอนเงินแล้ว ผู้บริจาคจะได้รับอีเมลยืนยันอีกครั้ง จึงจะถือว่าการบริจาคเสร็จสมบูรณ์  ")])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b08f78ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b08f78ac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadSlip.vue
// module id = 749
// module chunks = 1